// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"394":"e927fad4","435":"df9256dd","679":"20504752","845":"81685f09"}[chunkId] + ".css";
};